import React, { useState, useEffect } from "react";
import { MainAdminNewsesTop, MainAdminTablesNews } from "../../components/"
import { axiosReq } from "../../commons/axiosReq";
import Cookies from 'universal-cookie';

const MainAdminLogs = () => {

    const titleRow = ["عنوان ", "تاریخ ", "کاربر","توضیحات"];

    const [showEditModal, setShowEditModal] = React.useState(false);
    const [showDeleteModal, setShowDeleteModal] = React.useState(false);
    const [data, setData] = useState();
    const [search, setSearch] = useState("");
    const [reCheck, setRecheck] = useState(false);

    const [cats, setCats] = useState();
    const [cat, setCat]= useState(0);
        const [users, setUsers] = useState();
    const [user, setUser]= useState(0);
    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");
    const [prominent, setProminent] = useState(false);
    const [last, setLast] = useState(false);
    const [most, setMost] = useState(false);
    const [main, setMain] = useState(false);
    const [admins, setAdmins] = useState();
    const [admin, setAdmin] = useState();
    const [count, setCount] = useState();
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
    const [paginatedData, setPaginatedData] = useState([]); // For storing paginated results

    // const GetData = async () => {
    //    const writersData = await axiosReq("user/GetLogs","get")
    //     console.log(writersData)
    //     setData(writersData)
    //     setCount(writersData?.length)

    // }
   



const GetData = async () => {
    try {
        const writersData = await axiosReq("user/GetLogs?userLogTypeId="+cat+"&&startDate="+start+"&&endDate="+end+"&&userId="+user, "get");
        console.log(writersData);
        setData(writersData);
        setCount(writersData?.length || 0);
        
        // Calculate paginated data
        const startIndex = (page - 1) * row;
        const endIndex = startIndex + row;
        const currentPageData = writersData?.sort((a, b) => new Date(b.date) - new Date(a.date)).slice(startIndex, endIndex) || [];
        setPaginatedData(currentPageData);
        
    } catch (error) {
        console.error("Error fetching data:", error);
        setCount(0);
        setData([]);
        setPaginatedData([]);
    }
};

const GetTypes = async () => {
    try {
        const writersData = await axiosReq("user/GetLogTypes", "get");
        console.log(writersData);
        var type=[]
        writersData.map((item)=>{
type.push({label:item.title,value:item.userLogTypeId})
        })
        setCats(type);
      
        
    } catch (error) {
        console.error("Error fetching data:", error);
      
    }
};
const GetUsers = async () => {
    try {
        const writersData = await axiosReq("user/GetUsers", "get");
        console.log(writersData);
        var type=[]
        writersData.map((item)=>{
type.push({label:item.name+" "+item.family,value:item.userId})
        })
        setUsers(type);
      
        
    } catch (error) {
        console.error("Error fetching data:", error);
      
    }
};
    useEffect(() => {
GetTypes()
        GetUsers();
    }, []);
// Add useEffect to handle pagination when page or row changes
useEffect(() => {
    if (data?.length > 0) {
        const startIndex = (page - 1) * row;
        const endIndex = startIndex + row;
        const currentPageData = data.slice(startIndex, endIndex);
        setPaginatedData(currentPageData);
    }
}, [page, row, data]);

    useEffect(() => {

        GetData();
    }, [reCheck, search, page, row, cat, start, end,
        admin, prominent, last, most, main,user]);


    return (
        <div>
            <div><MainAdminNewsesTop mode={true} cats={cats} setCat={setCat} users={users} setUser={setUser} setStart={setStart} start={start} end={end} 
            setEnd={setEnd} setAdmin={setAdmin} setSearch={setSearch}
                setProminent={setProminent} setLast={setLast} setMost={setMost} setMain={setMain} admins={admins}
            >لاگها</MainAdminNewsesTop></div>


            <div className="pt-[20px] px-[20px] pb-[280px]">
                <MainAdminTablesNews detail={true} edit={false} block={false} deleted={false} 
                    setShowEditModal={setShowEditModal} setShowBlockModal={null} setShowDeleteModal={setShowDeleteModal}
                    titleRow={titleRow}  data={paginatedData} setRecheck={setRecheck} reCheck={reCheck}
                    count={count} page={page} setPage={setPage} row={row} setRow={setRow} />
            </div>

        </div>
    )
}

export default MainAdminLogs;